// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.sample_template_type */
var SampleTemplateType;
(function (SampleTemplateType) {
    SampleTemplateType["single"] = "single";
    SampleTemplateType["series"] = "series";
})(SampleTemplateType || (SampleTemplateType = {}));
;
export default SampleTemplateType;
/** Zod schema for sample_template_type */
export const sampleTemplateType = z.nativeEnum(SampleTemplateType);
//# sourceMappingURL=SampleTemplateType.js.map